import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { PageHeader } from '../../components/common/PageHeader';
import { appRoutes } from '../../app-routes';
import { EngageSettingsTab } from './engage-settings-tab';
import { EngageSegmentsTab } from './engage-segments-tab';
import { EngageAutomationsTab } from './engage-automations-tab';

type TabName = 'settings' | 'segments' | 'automations';

function getValidTab(tab: string | undefined): TabName {
  let tabName = tab === 'segments' || tab === 'automations' ? tab : 'settings';
  return tabName as TabName;
}

export const EngageSettingsNavigator: React.FC = () => {
  const { tab = 'settings' } = useParams();
  const navigate = useNavigate();

  const activeTab = getValidTab(tab);
  useEffect(() => {
    const isValidTab = ['settings', 'segments', 'automations'].includes(tab);
    if (!isValidTab) {
      navigate('/dashboard/engage/settings', { replace: true });
    }
  }, [tab, navigate]);

  const handleTabChange = (newTab: string) => {
    const tabToNavigateTo = getValidTab(newTab);
    const newPath = `${appRoutes.ENGAGE_SETUP}/${tabToNavigateTo}`;
    navigate(newPath, { replace: true });
  };

  const components = {
    segments: EngageSegmentsTab,
    automations: EngageAutomationsTab,
    settings: EngageSettingsTab,
  };
  const TabComponent = components[activeTab];

  const engageDescription =
    'Configure settings and manage automation templates';

  return (
    <section className="space-y-6">
      <PageHeader title="Engage" description={engageDescription} />
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
        className="space-y-6">
        <TabsList className="grid w-full max-w-2xl grid-cols-3">
          <TabsTrigger value="settings">Settings</TabsTrigger>
          <TabsTrigger value="automations">Automations</TabsTrigger>
          <TabsTrigger value="segments">Segments</TabsTrigger>
        </TabsList>
        <TabComponent />
      </Tabs>
    </section>
  );
};
